import { useAuth } from "@/contexts/AuthContext";
import TradeOrgDashboardRouter from "@/dashboards/trade_org/TradeOrgDashboardRouter";
import CrewArchetypeRouter from "@/dashboards/crew/CrewArchetypeRouter";
import StudioDashboard from "./StudioDashboard";
import VendorDashboard from "./VendorDashboard";
import AgencyOffice from "./AgencyOffice";
import CastingAgencyDashboard from "./CastingAgencyDashboard";
import TalentManagementDashboard from "./TalentManagementDashboard";
import PRAgencyDashboard from "./PRAgencyDashboard";
import EventProductionDashboard from "./EventProductionDashboard";
import StudioNetworkDashboard from "./StudioNetworkDashboard";
import DistributorDashboard from "./DistributorDashboard";
import SalesAgentDashboard from "./SalesAgentDashboard";
import ExhibitorDashboard from "./ExhibitorDashboard";
import TheaterGroupDashboard from "./TheaterGroupDashboard";
import TheaterHallDashboard from "./TheaterHallDashboard";
import Dashboard from "./Dashboard";

/** Dispatches the right dashboard based on the logged-in user's
 *  account_type. Every persona minted by /onboard/* has its own
 *  landing shell — the generic <Dashboard /> is now reserved for
 *  crew (default), production_house, admin and investor personas.
 *
 *  Feb 2026 · New: wizard-registered crew (path + department_key)
 *  gets routed to one of 7 archetype consoles via
 *  <CrewArchetypeRouter/> BEFORE the legacy switch runs.  If the
 *  archetype router returns null (legacy user, no wizard fields),
 *  we fall through to the existing owner/legacy routing.
 */
export default function OrgDashboardRouter() {
  const { user } = useAuth();
  if (!user) return null;

  // 1. Wizard-signup crew → one of 7 archetype consoles.
  if (user.account_type === "crew" && user.onboard_path && user.department_key) {
    return <CrewArchetypeRouter />;
  }

  // 2. Owner / staff-of-org account types → their own dashboards.
  switch (user.account_type) {
    case "association_admin":                return <TradeOrgDashboardRouter />;
    case "studio_admin":                     return <StudioDashboard />;
    case "vendor":                           return <VendorDashboard />;
    case "advertising_agency_admin":         return <AgencyOffice />;
    case "casting_agency_admin":             return <CastingAgencyDashboard />;
    case "talent_management_agency_admin":   return <TalentManagementDashboard />;
    case "pr_agency_admin":                  return <PRAgencyDashboard />;
    case "event_production_admin":           return <EventProductionDashboard />;
    case "studio_network_admin":             return <StudioNetworkDashboard />;
    case "distributor_admin":                return <DistributorDashboard />;
    case "sales_agent_admin":                return <SalesAgentDashboard />;
    case "exhibitor_admin":                  return <ExhibitorDashboard />;
    case "theater_group_admin":              return <TheaterGroupDashboard />;
    case "theater_hall_admin":               return <TheaterHallDashboard />;
    default:                                 return <Dashboard />;   // crew · production_house · investor · admin · studio_producer
  }
}
